import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { CommentDeepFragment } from '../../gql/graphql';
import Comment from './Comment';

interface CommentWithRepliesProps {
  CommentComponent: ReactNode;
  id: string;
  replies: CommentDeepFragment[];
}

function CommentWithReplies({
  CommentComponent,
  id,
  replies,
}: CommentWithRepliesProps) {
  const buildReplies = () => {
    return replies
      .sort((a, b) => a.createdAtTz.localeCompare(b.createdAtTz))
      .map((reply) => (
        <Comment
          key={reply.id}
          content={reply.content}
          id={reply.id}
          parentId={id}
          // replies={reply.replies}
          createdAt={reply.createdAtTz}
          user={{ username: reply.username }}
          projectId={''}
          takeoffId=""
          readBy={reply.readBy ? reply.readBy : []}
          elementIdentifiers={[]}
          savedViews={reply.savedViews ? reply.savedViews : undefined}
          commentId={reply.id}
          readOnlyMode
        />
      ));
  };

  return (
    <Box width={'100%'}>
      {CommentComponent}
      <Box className="replies_container">
        {replies.length > 0 && buildReplies()}
      </Box>
    </Box>
  );
}

export default CommentWithReplies;
